import { Icon } from '@vinted/web-ui'
import { ArrowLeft24, ArrowRight24 } from '@vinted/monochrome-icons'

import { ShowAtBreakpoint } from '@marketplace-web/shared/breakpoints'
import { InfluencerLifestyleModel } from '@marketplace-web/domain/marketing-landing-page-data'

import { LifestyleSectionCard } from './LifestyleSectionCard'
import SliderWrapper from '../../../../../../../../app/components/SliderWrapper'

type Props = { data: InfluencerLifestyleModel }

export const LifestyleSection = ({ data: { title, cards } }: Props) => {
  return (
    <section data-testid="lifestyle-section" className="influencer__lifestyle-section">
      <div className="influencer__lifestyle-section-inner">
        <h2 className="influencer__lifestyle-title">{title}</h2>
        <div className="influencer__lifestyle-cards-wrapper">
          <ShowAtBreakpoint breakpoint="portables">
            {cards.map((props, index) => (
              <LifestyleSectionCard {...props} key={index} index={index} />
            ))}
          </ShowAtBreakpoint>
          <ShowAtBreakpoint breakpoint="desktops">
            <SliderWrapper
              childData={cards.map((card, index) => ({ index, ...card }))}
              childComponent={LifestyleSectionCard}
              nextButton={<Icon name={ArrowRight24} />}
              previousButton={<Icon name={ArrowLeft24} />}
            />
          </ShowAtBreakpoint>
        </div>
      </div>
    </section>
  )
}
